export class MeasureModule {
  id: number;
  active_icon_link: string;
  description: string;
  height: number;
  inactive_icon_link: string;
  preview_image: string;
  show_up: number;
  template: string;
  name: string;
  isActive: boolean;
  position: number;
}



// WEBPACK FOOTER //
// ./src/models/measure/measure-module.ts